

















import { Modal, ModalMixin } from 'mycorems-app-shared';
import AccountSettings from './AccountSettings.vue';

export default ModalMixin.extend({
  components: { Modal, AccountSettings },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'CM Reports Settings',
    },
    unclosable: {
      type: Boolean,
      default: false,
    },
    preamble: String,
  },
  computed: {
    headerText(): string {
      if (this.preamble) return this.preamble;
      return 'You can add Report Recipients and modify the settings'
        + ' below at any time under individual account settings.';
    },
  },
  methods: {
    done(): void {
      this.$emit('ok');
      this.hide();
    },
  },
});
